import { render, staticRenderFns } from "./PaymentProductItem.vue?vue&type=template&id=b8bbac94&"
import script from "./PaymentProductItem.vue?vue&type=script&lang=js&"
export * from "./PaymentProductItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports